import api from "./Api";

class PedidoEnderecoEntregaService {
  GetPedidoEnderecoEntrega(payload) {
    return api.get("/v1/pedidoEnderecoEntrega/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoEnderecoEntrega(payload) {
    return api.post("/v1/pedidoEnderecoEntrega/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoEnderecoEntrega(payload) {
    return api.put("/v1/pedidoEnderecoEntrega/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoEnderecoEntrega(payload) {
    return api
      .delete("/v1/pedidoEnderecoEntrega/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidoEnderecoEntregaOData(payload) {
    return api
      .get("/OData/PedidoEnderecoEntrega" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PedidoEnderecoEntregaService();
